// Generated sandbox code: SSVMN - PlusTools - Editor v6.5.0 - 22/02/2022
// Created/Updated by jcanales - 17/10/2023

import { Component, OnDestroy, OnInit } from '@angular/core'
import { BaseController } from './base.controller';
import { Action, AuthService, CtDialogComponent, CtInputTextComponent, CtMessageComponent, CtOtpComponent, CtRadioComponent, CtRegexComponent, CtStepperComponent, CtStepperItemComponent, CtrlBaseComponent, EntityField, HttpService, PlusException, SpinnerService, TokenResponseModel } from 'components';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
	selector: 'sg-vi04',
	template: `<div [id]="getId()" #target><div>`
})

export class SgVi04 extends BaseController implements OnInit, OnDestroy{

	//properties
	private userIdentifier : string;
	private isUser : boolean;
	private userId : string;
	private userIdPatrono : string;
	private token : string;

	private ctStepper : CtStepperComponent;
	private otpComponent : CtOtpComponent;
	private ctMessage : CtMessageComponent;
	private confirmPasswordInput : CtInputTextComponent;

	//messages
	private readonly ACCOUNT_NOT_ASSOCIATED_ERROR = "El número de identificación proporcionado no pertenece a una persona asociada a nuestra institución.";
	private readonly NO_USER_CONTACTS = "Estimado(a) cliente, hemos identificado que no posee registrados medios de contacto. Le pedimos amablemente que actualice su información a través de los canales que la SSV pone a su disposición para garantizar una experiencia óptima.";
	public readonly EMAIL_TEXT : string = 'Enviar un correo a ';
	public readonly SMS_TEXT : string = 'Enviar un mensaje de texto al ';
	private readonly PASSWORD_REQUIREMENTS_ERROR = "La contraseña no cumple con los requisitos de seguridad";
	private readonly PASSWORDS_DO_NOT_MATCH = "Las contraseñas no coinciden";


	constructor(private authService : AuthService,
		private router : Router,
		private spinnerService : SpinnerService,
		private http : HttpClient) {
		super();
		this.setViewCode('SG_VI04');
	}

	ngOnDestroy(): void {
		this.storeService.deleteState('idPatrono');
		this.storeService.deleteState('tmpToken');
	}

	ngOnInit(): void {
		this.storeService.getStateObservable('idPatrono').subscribe({
			next : (result : any) => {
				this.userIdPatrono = result;
			}, 
			complete : () => {
				this.returnToLogin();
			}
		})
		this.storeService.getStateObservable('tmpToken').subscribe({
			next : (trm : string) => {
				this.token = trm;
			},
			complete : () => {
				this.returnToLogin();
			}
		});
	}

	/* ---------------------- CONTROLLER LOGIC ------------------- */
	public returnToLogin(): void {
		this.router.navigate(['/login']);
	}

	/**
	 * Executed on the 'next' button of the first step
	 * @param action 
	 */
	public setContactsToStepper(action : Action): void {
		this.ctStepper = this.utilService.getComponentRef(action.actionParams[0]);
		const inputComponent : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[1]);
		this.userId = inputComponent.getOldValue();
		this.ctMessage = this.utilService.getComponentRef(action.actionParams[2]);
		this.ctMessage.setHidden(true);
		this.ctMessage.setMessage('');
		this.getUserContacts(inputComponent);
	}

	private getUserContacts(inputComponent: CtInputTextComponent) {
		const stepperItemRadio : CtStepperItemComponent = this.ctStepper.getChildElements()[1] as CtStepperItemComponent;
		this.userIdentifier = inputComponent.getOldValue();
		inputComponent.isValid = true;
		this.authService.getLoginPreviewInfo(inputComponent.getOldValue()).subscribe({
			next: (response : any) => {
				this.checkUserStatus(response['Data'][0].ArrayEntities.List);
				this.setContactToStepperItem(response['Data'][0].ArrayEntities.List, stepperItemRadio);		
			},
			error: (err : any) => {
				inputComponent.isValid = false;
				if(err.error_code === 'DMZ.ERR_DMZ_USER_DEAD'){
					inputComponent.setRequiredMessage(err.description);
				} else {
					inputComponent.setRequiredMessage(this.ACCOUNT_NOT_ASSOCIATED_ERROR);
				}
			}
		});
	}

	private checkUserStatus(arrayEntitiesList: EntityField[]): void {
		arrayEntitiesList = arrayEntitiesList.filter((element : EntityField) => element.Name === 'IS_USER');
		if(arrayEntitiesList[0].Value === 'S'){
			this.isUser = true;
		} else {
			this.isUser = false;
		}
	}

	private setContactToStepperItem(arrayEntitiesList: EntityField[], stepperItem: CtStepperItemComponent) {
		let radioComponentsMetadata : any[] = [];
		arrayEntitiesList = arrayEntitiesList.filter((element : EntityField) => element.Name === 'EMAIL' || element.Name === 'CELULAR');

		for(let [index, element] of arrayEntitiesList.entries()) {
			if(element.Value === '' ||
				element.Value === null || 
				element.Value === undefined ||
				element.Value.toUpperCase() === 'NULL') continue;
			radioComponentsMetadata.push(this.getRadioComponentMetadata(element, index, element.Name));
		}
		if(!this.checkUserContacts(radioComponentsMetadata)) return;
		this.paintRadioComponents(radioComponentsMetadata, stepperItem);
	}

	private getRadioComponentMetadata(element: EntityField, index : number, type : string): any {
		return {
			ctType: "CtRadio",
			controlProperties: {
			  hidden: false,
			  listenedComponentId: "",
			  listenedProperty: "",
			  border: true,
			  isChecked: false,
			  readOnly: false,
			  labelValue: type === 'EMAIL' ? this.EMAIL_TEXT + element.Value : this.SMS_TEXT + element.Value,
			  value: element,
			  descriptionValue: "",
			  familyValue: "userContacts",
			  id: `RESETPASSWORD_LOGIN_CONTACTS_${index}`,
			  modelId: ""
			},
			controlActions: [],
			models: []
		};
	}

	private checkUserContacts(radioComponentsMetadata: any[]): boolean {
		if(radioComponentsMetadata.length === 0){
			this.ctMessage.setMessage(this.NO_USER_CONTACTS);
			this.ctMessage.setHidden(false);
			return false;
		}
		return true;
	}

	private paintRadioComponents(radioComponentsMetadata: any[], stepperItem: CtStepperItemComponent) {
		let metadata : any = stepperItem.getMetaData();
		metadata.models = radioComponentsMetadata;
		stepperItem.ngAfterViewInit();
		this.ctStepper.changeStep(this.ctStepper.getCurrentIndex() + 1);
	}

	/**
	 * 	Sends otp to the user's selected contact.
	 */
	public executeOtpDispatch(): void {
		const stepperItemRadio : CtRadioComponent[] = this.ctStepper.getChildElements()[1].getChildsByType(CtRadioComponent,true);
		const stepperItemOtp : CtOtpComponent[] = this.ctStepper.getChildElements()[2].getChildsByType(CtOtpComponent,true);
		this.otpComponent = stepperItemOtp[0];
		let contactChecked : boolean = false;

		for(let radio of stepperItemRadio){
			if(!radio.getIsChecked()) continue;
			contactChecked = true;
			stepperItemOtp[0].setDataToOtp(radio.getValue().Value, radio.getValue().Name, this.userIdentifier);
		}

		if(!contactChecked) return;
		stepperItemOtp[0].sendCode();
		this.ctStepper.changeStep(this.ctStepper.getCurrentIndex() + 1);
	}

	/**
	 * Validates the OTP code given by the user.
	 */
	public validateOtpCode(): void {
		if(this.otpComponent.getOtpCodeFromInput() === '') return;
		this.otpComponent.validateOtpCode();
   	}

	public postOtpValidation(action : Action): void {
		if(this.isUser){
			this.assignAdministrator(action);
		} else {
			this.ctStepper.changeStep(this.ctStepper.getCurrentIndex() + 1);
		}
	}

	public assignAdministrator(action : Action): void {
		if(this.isUser) this.assignAdministratorForValidUser(this.utilService.getComponentRef(action.actionParams[0]));
		else this.assignAdministratorForNewUser(action);
	}

	private assignAdministratorForNewUser(action: Action): void {
		this.spinnerService.show();
		const otpCode : string = this.otpComponent.getOtpCodeFromInput();
		const childInputs : CtInputTextComponent[] = this.ctStepper.getChildElements()[3].getChildsByType(CtInputTextComponent,true);
		const ctMessage : CtMessageComponent = this.utilService.getComponentRef(action.actionParams[2]);
		const ctDialog : CtDialogComponent = this.utilService.getComponentRef(action.actionParams[1]);
		this.confirmPasswordInput = childInputs[1];
		ctMessage.setHidden(true);
		
		if(!this.checkNewPasswordRequirements(childInputs)){
			this.spinnerService.hide();
			return;
		}

		const request : any = this.getAssignAdminRequest(childInputs[0].getOldValue(), childInputs[1].getOldValue());
		this.getAsociadosPlanilla(request).subscribe({
			next : () => {
				ctDialog.openDialog();
				this.spinnerService.hide();
			},
			error : (error : PlusException) => {
				ctMessage.setHidden(false);
				ctMessage.setMessage(error.description);
			}
		})
	}

	private assignAdministratorForValidUser(dialog : CtDialogComponent) {
		this.spinnerService.show();
		const request : any = this.getAssignAdminRequest();
		this.getAsociadosPlanilla(request).subscribe({
			next : () => {
				dialog.openDialog();
				this.spinnerService.hide();
			},
			error : (err : any) => {
				this.spinnerService.hide();
				this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', err.description,
        			true, 'Aceptar', 'Cancelar');
			}
		})
	}

	private checkNewPasswordRequirements(childInputs : CtInputTextComponent[]): boolean {
		childInputs[1].isValid = true;
		if(childInputs[0].getOldValue() !== childInputs[1].getOldValue()){
			childInputs[1].isValid = false;
			childInputs[1].setRequiredMessage(this.PASSWORDS_DO_NOT_MATCH);
			return false;
		}

		const invalidRegex : number = childInputs[0].getRegexComponents().filter((children : CtrlBaseComponent) => {
			if(children.getCtType() === 'CtRegex'){
				const regexComponent : CtRegexComponent = children as CtRegexComponent;
				return !regexComponent.getIsValid();
			}
		}).length;

		if(invalidRegex > 0){
			childInputs[0].isValid = false;
			childInputs[0].setRequiredMessage(this.PASSWORD_REQUIREMENTS_ERROR);
			return false;
		}

		return true;
	}

	private getAssignAdminRequest(password? : string, confirmPassword? : string): any {
		return {
			"Type": 1,
			"UserCode": "SVA",
			"Source": "SVA",
			"Conditions":
			{
				"Data": [
					{
						"Name": "DOC_IDENTIFICACION",
						"Alias": "DOC_IDENTIFICACION",
						"Value": this.userId
					},
					{
						"Name": "ID_PATRONO",
						"Alias": "ID_PATRONO",
						"Value": this.userIdPatrono
					},
					{
						"Name": "PASSWORD",
						"Alias": "PASSWORD",
						"Value": password ? password : null
					},
					{
						"Name": "CONFIRM_PASSWORD",
						"Alias": "CONFIRM_PASSWORD",
						"Value": confirmPassword ? confirmPassword : null
					}
				]
			},
			"Data": []
		}
	}

	public getAsociadosPlanilla(request : any): Observable<any> {
		let headers = new HttpHeaders();
		headers = headers.set('Authorization', `bearer ${this.token}`);
		return this.http.post(HttpService.ENDPOINT + '/api/process/USER/SER_ASSIGN_ADMIN_SVA', request, { headers: headers });
	} 
	/* -------------------- END CONTROLLER LOGIC ----------------- */

}